/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _module = __webpack_require__(1);
	
	var $window = $(window);
	var windowWidth = $window.width();
	
	// メディアクエリ
	var mql = window.matchMedia('screen and (max-width: 1024px)');
	
	//preload
	
	(0, _module.preload)();
	
	//toggleHeader
	
	(0, _module.toggleHeader)();
	
	//pageTop
	
	(0, _module.pageTop)();
	
	//相関図アンカー
	
	(0, _module.anchorScroll)();
	
	$(window).on('load', function () {
	
	  setTimeout(function () {
	    $('#st-Loader .loader').addClass("load");
	  }, 0);
	  setTimeout(function () {
	    $('#st-Loader').addClass("hidden");
	  }, 300);
	  setTimeout(function () {
	    $('#st-Loader').remove();
	  }, 2000);
	  setTimeout(function () {
	    $('.js-loadingAnimation').addClass("is-animated");
	  }, 500);
	
	  charaModal();
	  charaChange();
	  scrollCommonAnime();
	});
	
	// ------------------------------------------------------------------------
	// scrollCommonAnime
	// ----- BOTH
	// ------------------------------------------------------------------------
	var scrollCommonAnime = function scrollCommonAnime() {
	
	  var controller = new ScrollMagic.Controller();
	  // const targets = document.querySelectorAll(".js-scrollAnimation");
	  // const targetsArray = Array.prototype.slice.call(targets); //Array
	  // targetsArray.forEach(target => {
	  // //シーンを作成
	  // const scene = new ScrollMagic.Scene({
	  //     triggerElement: target,
	  //     triggerHook: .8
	  //   })
	  //   .setClassToggle(target, "is-animated")
	  //   .addTo(controller);
	  // });
	
	  //ロゴ出現
	
	  //道出現
	  var scene = new ScrollMagic.Scene({
	    triggerElement: '#st-Footer',
	    triggerHook: 1,
	    offset: '-300'
	  }).setClassToggle('#road', 'road-Show2')
	  // .addIndicators()
	  .addTo(controller);
	
	  //　スクロールで発火系
	  var targets = document.querySelectorAll(".js-scrollAnimation");
	  var targetsArray = Array.prototype.slice.call(targets); //Array
	  targetsArray.forEach(function (target) {
	    //シーンを作成
	    var scene2 = new ScrollMagic.Scene({
	      triggerElement: target,
	      triggerHook: .9
	    }).setClassToggle(target, "is-animated").addTo(controller);
	  });
	};
	
	// ------------------------------------------------------------------------
	// smoke
	// ----- BOTH
	// ------------------------------------------------------------------------
	// smoke
	var smoke = function smoke(target) {
	  var elm = document.getElementById(target);
	  var elmWidth = elm.clientWidth;
	  var elmHeight = elm.clientHeight;
	  var app = new PIXI.Application(windowWidth, elmHeight, { transparent: true });
	  elm.appendChild(app.view);
	  app.stage.interactive = true;
	
	  var container = new PIXI.Container();
	  app.stage.addChild(container);
	
	  var flag = PIXI.Sprite.fromImage("/wordpress/wp-content/themes/road_teaser/assets/images/common/bg_smoke.png");
	  container.addChild(flag);
	  flag.x = 0;
	  flag.y = 0;
	  flag.width = app.renderer.width;
	  flag.height = app.renderer.height;
	
	  var displacementSprite = PIXI.Sprite.fromImage('/wordpress/wp-content/themes/road_teaser/assets/images/common/displacement_map_repeat.jpg');
	  //Make sure the sprite is wrapping.
	  displacementSprite.texture.baseTexture.wrapMode = PIXI.WRAP_MODES.REPEAT;
	  var displacementFilter = new PIXI.filters.DisplacementFilter(displacementSprite);
	  displacementFilter.padding = 0;
	
	  displacementSprite.position = flag.position;
	
	  app.stage.addChild(displacementSprite);
	
	  flag.filters = [displacementFilter];
	
	  displacementFilter.scale.x = app.renderer.width * 1;
	  displacementFilter.scale.y = app.renderer.height * 1;
	
	  app.ticker.add(function () {
	    //Offset the sprite position to make vFilterCoord update to larger value. Repeat wrapping makes sure there's still pixels on the coordinates.
	    displacementSprite.x++;
	    //Reset x to 0 when it's over width to keep values from going to very huge numbers.
	    if (displacementSprite.x > displacementSprite.width) displacementSprite.x = 0;
	  });
	
	  $(window).on("load resize", function () {
	    app.renderer.resize(elm.clientWidth, elm.clientHeight);
	    flag.width = app.renderer.width;
	    flag.height = app.renderer.height;
	  });
	};
	smoke('smoke');
	
	// ------------------------------------------------------------------------
	// charaModal();
	// ----- BOTH
	// ------------------------------------------------------------------------
	var charaModal = function charaModal() {
	
	  var $modal = $('#character-cast_Stage');
	  var $modalClose = $('#character-cast_Stage_Close, #CloseSP');
	  var $modalPrev = $('#character-cast_Stage_Prev');
	  var $modalNext = $('#character-cast_Stage_Next');
	  var $modalInner = $('#character-cast_Stage_Inner');
	
	  var scrollPosition = void 0;
	  var ua = window.navigator.userAgent.toLowerCase();
	  var isiOS = ua.indexOf('iphone') > -1 || ua.indexOf('ipad') > -1 || ua.indexOf('macintosh') > -1 && 'ontouchend' in document;
	  var body = document.querySelector('body');
	
	  var _currentNum;
	  var _oldNum;
	  var ALL_NUM;
	  ALL_NUM = $('.character-cast_Stage_Inner_Profile').length;
	  var posi;
	
	  // タブのパラメータがついている時の対応
	  var param = getParam('id');
	  if (param != null) {
	    if ($('[data-modal-content="' + param + '"]').length > 0) {
	      modalOpen(param);
	    }
	  }
	
	  // 一覧から開く
	  $(document).on('click', '[data-modal-link]', function (e) {
	    e.preventDefault();
	    var target = $(this).data('modalLink');
	    modalOpen(target);
	  });
	
	  // 閉じるボタン
	  $modalClose.on('click', function (e) {
	    e.preventDefault();
	    modalClose();
	  });
	
	  function getParam(name, url) {
	    if (!url) url = window.location.href;
	    name = name.replace(/[\[\]]/g, "\\$&");
	    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
	        results = regex.exec(url);
	    if (!results) return null;
	    if (!results[2]) return '';
	    return decodeURIComponent(results[2].replace(/\+/g, " "));
	  }
	
	  // モーダルを開く
	  function modalOpen(target) {
	
	    // モーダルが開いたら、bodyにfixedを付与
	    bodyFixedOn();
	
	    $('[data-modal-content = ' + target + ']').addClass('is-show');
	    $modal.addClass('opened');
	    _currentNum = $('[data-modal-content = ' + target + ']').data('modal-num');
	    _oldNum = _currentNum;
	
	    // パラメータ付与
	    var setParam = '?id=' + target;
	    history.pushState(null, null, setParam);
	
	    // モーダルのスクロール位置上に
	    scrollChara();
	  }
	
	  // モーダルを閉じる
	  function modalClose() {
	    $('[data-modal-content]').removeClass('is-show');
	    $modal.removeClass('opened');
	
	    // パラメータ初期化
	    history.pushState(null, null, '/character-cast/');
	
	    // モーダルが閉じられたら、スクロールのトップを取得してbodyに
	    bodyFixedOff();
	    charaScale();
	  }
	
	  // 前へ切り替えボタン
	  $modalPrev.on('click', function () {
	
	    _currentNum--;
	
	    if (_currentNum < 0) {
	      _currentNum = ALL_NUM - 1;
	    }
	
	    changeDetail();
	    scrollChara();
	    charaScale();
	  });
	
	  // 次へ切り替えボタン
	  $modalNext.on('click', function () {
	
	    // console.log(ALL_NUM)
	
	    _currentNum++;
	
	    if (_currentNum > ALL_NUM - 1) {
	      _currentNum = 0;
	    }
	
	    changeDetail();
	    scrollChara();
	    charaScale();
	  });
	
	  // 切り替え
	  function changeDetail() {
	
	    var _oldTarget = $('.character-cast_Stage_Inner_Profile').eq(_oldNum);
	
	    var target = $('.character-cast_Stage_Inner_Profile').eq(_currentNum);
	
	    _oldTarget.removeClass("is-show");
	
	    // changeControl();
	
	    target.addClass("is-show");
	
	    _oldNum = _currentNum;
	
	    // パラメータ変更
	    var targetId = $(target).data('modal-content');
	    // パラメータ付与
	    var setParam = '?id=' + targetId;
	    history.pushState(null, null, setParam);
	  }
	
	  //モーダルのスクロール一番上へ
	  function scrollChara() {
	
	    $('#character-cast_Stage,#character-cast_Stage_Inner,.character-cast_Stage_Inner_Profile').scrollTop(0);
	  }
	
	  //bodyのスクロール固定
	  function bodyFixedOn() {
	    if (isiOS) {
	      scrollPosition = window.pageYOffset;
	      body.style.position = 'fixed';
	      body.style.top = "-" + scrollPosition + "px";
	    } else {
	      body.style.overflow = 'hidden';
	    }
	    // body.style.overflow = 'hidden';
	  }
	
	  function bodyFixedOff() {
	    if (isiOS) {
	      body.style.removeProperty('position');
	      body.style.removeProperty('top');
	      window.scrollTo(0, scrollPosition);
	    } else {
	      body.style.removeProperty('overflow');
	    }
	    // body.style.removeProperty('overflow');
	  }
	};
	
	// ------------------------------------------------------------------------
	// charaChange();
	// ----- BOTH
	// ------------------------------------------------------------------------
	var $changeBtn = $('.btn-scale');
	var $illust = $('.illust');
	var _isChange = false;
	
	var charaChange = function charaChange() {
	
	  $changeBtn.on('click', function () {
	    if (!_isChange) {
	
	      setTimeout(function () {
	        //縮小
	        charaScaleDown();
	      }, 0);
	    } else {
	
	      setTimeout(function () {
	        //拡大
	        charaScale();
	      }, 0);
	    }
	  });
	};
	
	//縮小
	var charaScaleDown = function charaScaleDown() {
	
	  $changeBtn.addClass('whole');
	  $illust.addClass('whole');
	  _isChange = true;
	};
	
	//拡大
	var charaScale = function charaScale() {
	
	  $changeBtn.removeClass('whole');
	  $illust.removeClass('whole');
	  _isChange = false;
	};

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var headerFlag = false;
	var stHeaderNav = document.getElementById('st-Header_Nav');
	var stHeaderBg = document.getElementById('st-Header_Bg');
	var stHeaderLogo = document.getElementById('st-Logo');
	var headerButton = document.getElementById('st-Menu');
	var $window = $(window);
	var breakPoint = 1024;
	var windowWidth = $window.width();
	var windowHeight = $window.height();
	
	// var windowW       = $(window).width();
	// var windowH       = $(window).innerHeight();
	// var _isSP         = false;
	// var _isipad  = false;
	
	
	// ------------------------------------------------------------------------
	// preload
	// ----- BOTH
	// ------------------------------------------------------------------------
	var preload = function preload() {
	
	  history.replaceState(null, null, null);
	  window.addEventListener('popstate', function () {
	
	    // $('body').addClass('preload');
	
	    headerFlag = false;
	    stHeaderNav.classList.remove('opened');
	    headerButton.classList.remove('opened');
	    stHeaderBg.classList.remove('opened');
	    stHeaderLogo.classList.remove('opened');
	    stHeaderNav.classList.add('closed');
	    headerButton.classList.add('closed');
	    stHeaderBg.classList.add('closed');
	    stHeaderLogo.classList.add('closed');
	
	    // setTimeout(function(){
	    //   $('body').removeClass('preload');
	    // },100);
	  }, false);
	
	  $(window).on('load', function () {
	    $("body").removeClass("preload");
	  });
	
	  //objectFit
	  objectFitImages();
	};
	
	// ------------------------------------------------------------------------
	// toggleHeader
	// ----- BOTH
	// ------------------------------------------------------------------------
	var toggleHeader = function toggleHeader() {
	
	  headerButton.addEventListener('click', function () {
	
	    if (!headerFlag) {
	      // $('#st-Header_Navi').css({'display':'block'});
	      setTimeout(function () {
	        stHeaderNav.classList.remove('closed');
	        headerButton.classList.remove('closed');
	        stHeaderBg.classList.remove('closed');
	        stHeaderLogo.classList.remove('closed');
	        stHeaderNav.classList.add('opened');
	        headerButton.classList.add('opened');
	        stHeaderBg.classList.add('opened');
	        stHeaderLogo.classList.add('opened');
	        headerFlag = true;
	      }, 0);
	    } else {
	      stHeaderNav.classList.remove('opened');
	      headerButton.classList.remove('opened');
	      stHeaderBg.classList.remove('opened');
	      stHeaderLogo.classList.remove('opened');
	      stHeaderNav.classList.add('closed');
	      headerButton.classList.add('closed');
	      stHeaderBg.classList.add('closed');
	      stHeaderLogo.classList.add('closed');
	      headerFlag = false;
	      // setTimeout(function(){
	      //   // $('#st-Header_Navi').css({'display':'none'});
	      // },0);
	    }
	  }, false);
	};
	
	// ------------------------------------------------------------------------
	// pageTop
	// ----- BOTH
	// ------------------------------------------------------------------------
	var pageTop = function pageTop() {
	
	  $("#st-Top").on("click", function () {
	    var linkSpeed = 800;
	    $("html, body").animate({ scrollTop: 0 }, linkSpeed, "easeOutExpo");
	    return false;
	  });
	};
	
	// ------------------------------------------------------------------------
	// showMovie
	// ----- BOTH
	// ------------------------------------------------------------------------
	var showMovie = function showMovie() {
	  var $modal = $('#movie-Stage');
	  var $content = $('#movie-Iframe');
	
	  // open
	  $('.js-Youtube').on('click', function () {
	
	    var dataID = $(this).attr('data-youtube');
	
	    $('#movie-Stage').css({ 'opacity': '0', 'display': 'block' }).stop().animate({ 'opacity': '1', 'width': 100 + '%', 'height': 100 + 'vh', 'top': 0, 'left': 0 }, 300, 'easeOutQuart', function () {
	      //iframe append
	      $content.append('<iframe width="900" height="506" src="https://www.youtube.com/embed/' + dataID + '?rel=0&amp;autoplay=1" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen" frameborder="0"></iframe>');
	      // fadeIn
	      $modal.stop().fadeIn(400);
	      return false;
	    });
	  });
	
	  //close
	  $('#movie-Close,#movie-Iframe').on('click', function () {
	
	    $('#movie-Stage').css({ 'opacity': '1' }).stop().animate({ 'opacity': '0' }, 300, 'easeOutQuart', function () {
	      $('#movie-Stage').css({ 'display': 'none' });
	      $content.children('iframe').remove();
	    });
	  });
	};
	
	// ------------------------------------------------------------------------
	// anchorLink
	// ----- BOTH
	// ------------------------------------------------------------------------
	var anchorScroll = function anchorScroll() {
	  var $anchor = $('.to-correlation');
	  $anchor.click(function () {
	    var speed = 1000;
	    var href = $(this).attr('href');
	    var target = $(href == '#' || href == '' ? 'html' : href);
	    var position = target.offset().top;
	    if (windowWidth > breakPoint) {
	      position = target.offset().top - windowWidth * 0.052;
	    } else {
	      position = target.offset().top - windowWidth * 0.24;
	    }
	    $('html, body').animate({
	      scrollTop: position
	    }, speed, 'swing');
	  });
	};
	
	exports.preload = preload;
	exports.toggleHeader = toggleHeader;
	exports.pageTop = pageTop;
	exports.showMovie = showMovie;
	exports.anchorScroll = anchorScroll;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// character-cast/app.bundle.js